module.exports = __webpack_public_path__ + "static/media/SmartTV.c0a97f50.png";